<template>
  <Page class="games">
    <template #sidebar>
    </template>
    <template #topbar>
      <Topbar/>
    </template>
    <template #contentbar>
      <Contentbar>
        <template #left>
          <BButton
            class="games__btn-new-game"
            variant="primary"
            :disabled="newGame"
            @click="newGame = true"
          >
            Neues Spiel
          </BButton>
        </template>
      </Contentbar>
    </template>
    <template #default>
      <BListGroup class="games__list">
        <BListGroupItem
          v-for="(game, index) in games"
          :key="game.hash"
          class=""
          :class="{
            'border-top': game.loopIndex === 0,
            'mt-4': game.loopIndex === 0 && index !== 0,
            'ml-4': game.loopIndex > 0,
          }"
        >
          <RouterLink :to="{ name: 'game', params: { game: game.hash }}">{{ game.name }}</RouterLink>
        </BListGroupItem>
      </BListGroup>
      <ModalNewGame
        v-if="newGame"
        v-model="newGame"
        @create="onCreateGame"
      />
    </template>
  </Page>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import Topbar from '@/layout/components/Topbar.vue';
import Page from '@/layout/components/Page.vue';
import Contentbar from '@/layout/components/Contentbar.vue';
import ModalNewGame from './components/ModalNewGame.vue';
import utilities from './mixins/utilities';


export default {
  name: 'PageGames',
  components: {
    Contentbar,
    Topbar,
    Page,
    ModalNewGame,
  },
  mixins: [utilities],
  data() {
    return {
      newGame: false,
    };
  },
  created() {
    this.$store.dispatch('games/subscribe');
  },
  computed: {
    games() {
      if (this.$store.state.games.list == null) {
        return null;
      }
      return Object.values(this.$store.state.games.list)
        .filter(game => game.players.includes(this.$store.state.auth.uid))
        .map((currentGame) => {
          const game = { ...currentGame };
          let loopedGame = currentGame;
          let loopIndex = 0;
          while (loopedGame.previous != null) {
            loopedGame = this.$store.state.games.list[loopedGame.previous];
            loopIndex += 1;
          }
          game.comparableName = loopedGame.name;
          game.comparableHash = loopedGame.hash;
          game.loopIndex = loopIndex;
          return game;
        })
        .sort((gameA, gameB) => {
          if (gameA.comparableName < gameB.comparableName) {
            return -1;
          }
          if (gameA.comparableName > gameB.comparableName) {
            return 1;
          }
          if (gameA.comparableHash < gameB.comparableHash) {
            return -1;
          }
          if (gameA.comparableHash > gameB.comparableHash) {
            return 1;
          }
          return gameA.loopIndex - gameB.loopIndex;
        });
    },
  },
  methods: {
    async onCreateGame(args) {
      const newGame = {
        name: null,
        creator: this.$store.state.auth.uid,
        requiredPlayers: 4,
        hash: uuidv4(),
        players: [this.$store.state.auth.uid],
        rounds: [],
        ...args,
      };
      await this.$store.dispatch('games/create', {
        ...newGame,
        rounds: [this.getNewRoundForGame(newGame)],
      });
      this.$router.push({ name: 'game', params: { game: newGame.hash } });
      this.newGame = false;
    },
  },
};
</script>

<style scoped>
.games__list {
  margin: 15px 10px;
}

.games__btn-new-game {
  margin: 15px 10px;
}
</style>
